import { SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";

interface Props {
  handleSearch: (arg0: string) => void;
  placeholder: string;
  value: string;
}

const SearchBar: React.FC<Props> = ({ handleSearch, placeholder, value }) => {
  const onChange = (e: { target: { value: string } }) => {
    handleSearch(e.target.value);
  };

  return (
    <Input
      placeholder={placeholder}
      suffix={<SearchOutlined style={{ fontSize: "22px", color: "grey" }} />}
      size="large"
      onChange={onChange}
      style={{ padding: "0.6em" }}
      value={value}
    />
  );
};

export default SearchBar;

// TODO value ... må ha et value felt her som vi kan bruke for å resette verdien i event filter
